import React, { Dispatch, FC, SetStateAction } from 'react';

import Link from 'next/link';
import router from 'next/router';

import useIqfuProSellingContracts from '@hooks_iqfu/iqfu_pro/useIqfuProSellingContracts';

import DialogWrapper from '@components_iqfu/dashboard/dialog/dialog_wrapper/DialogWrapper';

import { NotificationText } from '@constants_iqfu';
import { useNotificationContext } from '@contexts_common/notificationContext';

import styles from './RequestInfoMapDialog.module.scss';

type Props = {
  sellingContractId: number;
  onClose: () => void;
  open: boolean;
  processingState: { isProcessing: boolean; setIsProcessing: Dispatch<SetStateAction<boolean>> };
  completeRequestState: { hasCompletedRequest: boolean; setHasCompletedRequest: Dispatch<SetStateAction<boolean>> };
  fullWidth?: boolean;
};

const RequestInfoMapDialog: FC<Props> = ({
  sellingContractId,
  onClose,
  open,
  processingState,
  completeRequestState,
  fullWidth,
}) => {
  const { setNotificationDisplay, setNotificationMessage, setNotificationStatus } = useNotificationContext();

  const { requestViewInformationMap } = useIqfuProSellingContracts();
  const { isProcessing, setIsProcessing } = processingState;
  const { hasCompletedRequest, setHasCompletedRequest } = completeRequestState;
  const userType = router.pathname.includes('financial_agency') ? 'financial_agency' : 'company';

  const handleRequestViewInformationMap = () => {
    const onSubmitSuccess = () => {
      setNotificationStatus('success');
      setNotificationMessage(NotificationText.successRequestViewInformationMap);
      setNotificationDisplay(true);
      setIsProcessing(false);
      setHasCompletedRequest(true);
    };
    const onSubmitFailed = () => {
      setNotificationStatus('alert');
      setNotificationMessage(NotificationText.error);
      setNotificationDisplay(true);
      setIsProcessing(false);
    };

    setIsProcessing(true);

    requestViewInformationMap({ userType, sellingContractId })
      .then(() => {
        onSubmitSuccess();
      })
      .catch(() => {
        onSubmitFailed();
      });
  };
  return (
    <>
      <DialogWrapper onClose={onClose} open={open} fullWidth={fullWidth}>
        <div className={styles.dialog_inner}>
          {!hasCompletedRequest ? (
            <>
              <p className={styles.title}>※販売図面取得</p>
              <p className={styles.dialog_alert_text}>
                1000円課金します。
                <br />
                よろしいですか？
              </p>
              <div className={styles.button_wrapper}>
                <button
                  className={styles.submit_button}
                  onClick={handleRequestViewInformationMap}
                  disabled={isProcessing}
                >
                  依頼する
                </button>
                <button className={styles.delete_button} onClick={onClose}>
                  キャンセル
                </button>
              </div>
            </>
          ) : (
            <>
              <p className={styles.complete_request_text}>
                販売図面の取得依頼をいただき、ありがとうございます。
                <br />
                ご依頼いただいた物件の販売図面を運営にて確認し、
                <br />
                2営業日以内に「
                <Link href={`/console/${userType}/chat/contact`} passHref>
                  <a className={styles.contact_link}>運営問合せ</a>
                </Link>
                」から改めてご連絡させていただきます。
                <br />
                <br />
                販売図面をご提供出来ない場合もございますので、予めご了承ください。
              </p>

              <button className={styles.close_button} onClick={() => onClose()}>
                閉じる
              </button>
            </>
          )}
        </div>
      </DialogWrapper>
    </>
  );
};

export default RequestInfoMapDialog;
